export default __webpack_public_path__ + "static/media/twitter.fd359657.svg";